import { render } from "./common-addon.vue?vue&type=template&id=ecc5a2cc"
import script from "./common-addon.vue?vue&type=script&lang=js"
export * from "./common-addon.vue?vue&type=script&lang=js"

import "./common-addon.vue?vue&type=style&index=0&id=ecc5a2cc&lang=scss"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.16_vue@3.5.13_typescript@5.1.6__webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__